import { render, staticRenderFns } from "./JEmpty.vue?vue&type=template&id=adeed880&"
import script from "./JEmpty.vue?vue&type=script&lang=js&"
export * from "./JEmpty.vue?vue&type=script&lang=js&"
import style0 from "./JEmpty.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports